// Phone numbers reach Brij from the consumer app's masked input, from Twilio
// webhooks, from Shopify orders and from brand imports. Everything downstream
// (the conversion-event lambdas, Twilio, Klaviyo, Postscript, Attentive) matches
// on E164, so a number has to be '+15551234567' by the time it is stored.
//
// Rules, in order:
//  1. The masked input writes '_' into every unfilled slot, so a value still
//     carrying one is an untouched or partially typed mask, never a real number.
//     This is what actually rejects mask artifacts; it works at any length, for
//     any country, which a digit-count threshold cannot do.
//  2. Strip every character that is not '+' or a digit.
//  3. Reject fewer than 4 digits. The longest country code in the app's 201
//     country configs is 3 digits, so a bare mask can never leave 4, while the
//     shortest real number any of these systems can hold is 7. Four digits of
//     margin, and it cannot reject a real number anywhere in the world.
//  4. Reject more than 15 digits, the E.164 maximum.
//  5. STRIP-ONLY: keep a leading '+' if the writer stored one, never invent one
//     (a number stored without a country code is ambiguous and must keep its
//     exact shape), and never leave a '+' stranded mid-string.
//
// Returns '' when there is no usable number, so callers can skip the write
// instead of overwriting a good stored value with a blank.
export const normalizePhoneNumber = (phoneNumber: unknown): string => {
  if (typeof phoneNumber !== 'string') return '';
  if (phoneNumber.includes('_')) return '';
  const stripped = phoneNumber.replace(/[^+\d]/g, '');
  const digits = stripped.replace(/\D/g, '');
  if (digits.length < 4) return '';
  if (digits.length > 15) return '';
  return (stripped.startsWith('+') ? '+' : '') + digits;
};
